import { ClipboardDocumentIcon } from "@heroicons/react/24/outline";
import { CheckBadgeIcon } from "@heroicons/react/24/solid";
import { ButtonBase } from "@repo/ui/index.tsx";
import { useEffect, useState } from "react";
import useJourneyRequests from "../../hooks/useJourneyRequests";

function TraceIdComp() {
  const [copyText, setCopyText] = useState(false);
  const {
    urlQueries,
    enquiryData,
    services: { enquiryService },
  } = useJourneyRequests();

  const traceId = enquiryData?.trace_id;
  //EFFECT/s
  useEffect(() => {
    if (copyText) {
      setTimeout(() => {
        setCopyText(false);
      }, 3000);
    }
  }, [copyText]);

  if (!urlQueries.enq) {
    return <></>;
  }

  if (enquiryService?.isLoading) {
    return (
      <div className="w-48 h-8 bg-extraLightGray animate-pulse rounded-lg" />
    );
  }

  return (
    <ButtonBase
      onClick={() => {
        if (copyText) return;
        navigator.clipboard.writeText(traceId);
        setCopyText(true);
      }}
      className="px-4 max-sm:px-2 h-8 bg-offWhite gap-1 flex items-center"
      buttonType="tertiary"
      text={
        <p className="text-xs font-semibold text-heading">
          <span className="max-sm:hidden text-darkGray">Reference Id:</span>{" "}
          {copyText ? "Copied!" : traceId}
        </p>
      }
      icon={
        copyText ? (
          <CheckBadgeIcon className="max-sm:hidden size-5 text-success" />
        ) : (
          <ClipboardDocumentIcon className="max-sm:hidden  size-4" />
        )
      }
    />
  );
}

export default TraceIdComp;
